
import { getJpServiceCards } from '../jpServiceCardData'

export default {
  name: 'JpServiceCards',
  props: {
    /**
     * 子产品的 code（URL 中的 detailName，如 fast / bulk / discts / delivery / package）
     */
    detailCode: {
      type: String,
      default: '',
    },
  },
  computed: {
    cards() {
      const rawCards = getJpServiceCards(this.detailCode)
      if (!rawCards) return null
      return rawCards.map((card) => ({
        icon: card.icon,
        title: this.$t(card.titleKey),
        detail: this.$t(card.detailKey),
      }))
    },
  },
}
